// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__1oTlk","topBottomGutter":"Layout_topBottomGutter__1QET0"};